import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { swimminglyApi } from "./utils/helperFunctions"

interface AdminApprovalActionProps {
  action: "approve" | "reject"
}

type ActionStatus = "loading" | "success" | "already_acted" | "expired" | "not_found" | "error"

const statusMessages: Record<ActionStatus, { title: string; body: string }> = {
  loading: { title: "Processing...", body: "Please wait while we process your request." },
  success: { title: "Done!", body: "" },
  already_acted: { title: "Already Processed", body: "This request has already been approved or rejected." },
  expired: { title: "Request Expired", body: "This approval request has expired and can no longer be acted upon." },
  not_found: { title: "Not Found", body: "This approval link is invalid or has already been used." },
  error: { title: "Something went wrong", body: "An error occurred. Please try again later." },
}

export default function AdminApprovalAction({ action }: AdminApprovalActionProps) {
  const { token } = useParams<{ token: string }>()
  const [status, setStatus] = useState<ActionStatus>("loading")
  const [serverMessage, setServerMessage] = useState<string>("")

  useEffect(() => {
    if (!token) {
      setStatus("not_found")
      return
    }

    const endpoint = action === "approve" ? "/api/approveAdminRequest" : "/api/rejectAdminRequest"

    swimminglyApi
      .post(endpoint)
      .body({ token })
      .then((response: any) => {
        if (response?.status === "approved" || response?.status === "rejected") {
          setStatus("success")
          setServerMessage(response.message || "")
        } else if (response?.status === "already_approved" || response?.status === "already_rejected") {
          setStatus("already_acted")
          setServerMessage(response.message || "")
        } else if (response?.status === "expired") {
          setStatus("expired")
          setServerMessage(response.message || "")
        } else {
          setStatus("error")
          setServerMessage(response?.message || "")
        }
      })
      .catch(() => {
        setStatus("error")
      })
  }, [token, action])

  const info = statusMessages[status]
  const successBody =
    action === "approve"
      ? "The admin access request has been approved. The user will receive an email notification."
      : "The admin access request has been rejected. The user will receive an email notification."

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f5f5f5",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "40px",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          maxWidth: "480px",
          width: "100%",
          textAlign: "center",
        }}
      >
        {status === "loading" && (
          <>
            <p style={{ fontSize: "18px", color: "#555" }}>Processing...</p>
          </>
        )}
        {status !== "loading" && (
          <>
            <h2 style={{ color: status === "success" ? "#1a73e8" : status === "error" ? "#d93025" : "#333" }}>
              {info.title}
            </h2>
            <p style={{ color: "#555" }}>{status === "success" ? successBody : serverMessage || info.body}</p>
          </>
        )}
      </div>
    </div>
  )
}
